export const SaveOutlineIcon = (props) => (
  <svg fill="none" height={18} stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24" width={18} {...props}>
    <path
      d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M17 21v-8H7v8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 3v5h8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
